// Core
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import { GeckoRow } from 'ui';
import { Chart } from 'react-google-charts';
import WidgetTotalHeader from '../../../components/WidgetTotalHeader';
import StatsLoader from '../../../components/StatsLoader';

// Other
import StatsLogic from '../../../Logic/StatsLogic';
import graphColours from 'constants/graphColours';

function MessagesSent(props) {
  // Using newConversations data for now until data is given from API.
  const sentMessagesByDay = useSelector(
    (state) => state.statsRoute.sentMessagesByDay
  );

  const startDate = useSelector(
    (state) => state.statsRoute.conversationStartDateFilter
  );
  const endDate = useSelector(
    (state) => state.statsRoute.conversationEndDateFilter
  );

  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingMessagesSentStats
  );

  let totalMessages = 0;

  let data = [];
  if (sentMessagesByDay.length) {
    const messages = StatsLogic.formatConversationStats(
      sentMessagesByDay,
      startDate,
      endDate
    );
    messages.forEach((responsePeriod) => {
      totalMessages += responsePeriod.value;
      data.push([responsePeriod.label, responsePeriod.value]);
    });
  }

  const header = ['date', 'Messages'];
  const graphData = data.length ? [header, ...data] : [header, ['', 0]];

  const graphOptions = {
    hAxis: {
      title: '',
      minValue: 0,
      labelWrap: false,
      slantedText: true,
      slantedTextAngle: StatsLogic.getSlantedTextAngleForRange(
        props.currentPeriod
      ),
    },
    vAxis: {
      title: 'Messages',
      format: '#,###',
      minValue: 0,
      maxValue: 4,
      gridlines: { count: -1 },
    },
    legend: 'none',
    tooltip: { isHtml: true },
    focusTarget: 'category',
    colors: [graphColours.primary],
  };

  return (
    <div>
      <StatsLoader isLoading={fetchingStats}>
        <GeckoRow>
          <div className="col">
            <WidgetTotalHeader
              primary={totalMessages}
              suffix={
                <span style={{ fontSize: '14px' }}>
                  {'Total Sent Messages'}
                </span>
              }
              showSecondary={false}
            />
          </div>
        </GeckoRow>

        <GeckoRow>
          <div className="col">
            <Chart
              chartType="ColumnChart"
              data={graphData}
              options={graphOptions}
              graph_id={props.id}
              width="100%"
              height="400px"
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
}

export default MessagesSent;
